import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import propTypes from 'prop-types';
import Modal from '../../../components/Modal';
import useAssemblyActions from '../../../hooks/useAssemblyActions';

export default function AssemblyPutSuccess({ assembly, isEdit }) {
  const history = useHistory();
  const title = (assembly.type === 'meeting' && 'Reunião') || 'Assembleia';
  const { open } = useAssemblyActions({
    assembly,
    onCompleted: () => history.push('/dashboard'),
  });

  return (
    <Modal className="bg-light text-center" sm>
      <div className="modal-content">
        <div className="modal-body">
          <p>:)</p>
          <p>{`Sua ${title.toLowerCase()} foi ${isEdit ? ' editada ' : ' criada '} com sucesso!`}</p>

          <button type="button" className="btn btn-primary btn-block" onClick={() => open()}>
            {`Abrir ${title} e convidar condôminos`}
          </button>
          <p className="text-muted mt-2">
            {`Quando sua ${title.toLowerCase()} for iniciada, os condôminos poderão fazer comentários e votar.`}
          </p>
        </div>
        <div className="modal-footer">
          <Link className="btn btn-link btn-block" to="/dashboard">
            Fazer isso mais tarde
          </Link>
        </div>
      </div>
    </Modal>
  );
}

AssemblyPutSuccess.propTypes = {
  assembly: propTypes.object.isRequired,
  isEdit: propTypes.bool,
};

AssemblyPutSuccess.defaultProps = {
  isEdit: false,
};
